import base2 from './base2.repository';

export default {
    get: (params) => base2.get('clients/areas', params),
    getById: (id) => base2.get(`clients/areas/${id}`),
    save: (payload) => base2.post('clients/areas', payload),
    update: (id, payload) => base2.put(`clients/areas/${id}`, payload),
    delete: (id) => base2.delete(`clients/areas/${id}`),
}

